import { Directive, ElementRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { animate, AnimationBuilder, style } from '@angular/animations';

@Directive({
  selector: '[appAnimatedCounter]',
  standalone: true
})
export class AnimatedCounterDirective implements OnChanges {
  @Input() appAnimatedCounter: number = 0;
  @Input() duration: number = 1500; // ms
  @Input() prefix: string = '';
  @Input() suffix: string = '';
  @Input() decimals: number = 0;

  private el = inject(ElementRef);
  private animationBuilder = inject(AnimationBuilder);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appAnimatedCounter']) {
      this.animateValue(this.appAnimatedCounter);
    }
  }

  private animateValue(end: number): void {
    const start = 0;
    const startTime = performance.now();
    
    const updateCounter = (currentTime: number) => {
      const progress = Math.min((currentTime - startTime) / this.duration, 1);
      // Easing function for smooth animation
      const easeOutQuad = progress => progress * (2 - progress);
      const easedProgress = easeOutQuad(progress);
      
      const currentValue = start + (end - start) * easedProgress;
      this.el.nativeElement.textContent = 
        this.prefix + currentValue.toFixed(this.decimals) + this.suffix;
      
      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    };
    
    requestAnimationFrame(updateCounter);
  }
}